import { supabase } from '../lib/supabase'
import {
  CALCULADORA_PARAM_KEYS,
  type CalculadoraParametrosConfig,
  type ComercialCalculadoraParameter,
} from '../types/comercialCalculadoras'
import { COMISSAO_PADRAO, NR1_VALOR_POR_VIDA } from '../utils/calculadoraNr1'

export const DEFAULT_CALCULADORA_PARAMETROS: CalculadoraParametrosConfig = {
  nr1ValorIndividual: NR1_VALOR_POR_VIDA,
  comissaoPercentualMaximo: 100,
}

export function parseCalculadoraParametros(
  parameters: ComercialCalculadoraParameter[]
): CalculadoraParametrosConfig {
  const byKey = Object.fromEntries(parameters.map((p) => [p.key, p.value]))

  const nr1Raw = parseFloat(byKey[CALCULADORA_PARAM_KEYS.NR1_VALOR_INDIVIDUAL] ?? '')
  const comissaoMaxRaw = parseFloat(byKey[CALCULADORA_PARAM_KEYS.NR1_COMISSAO_PERCENTUAL_MAXIMO] ?? '')

  return {
    nr1ValorIndividual:
      Number.isFinite(nr1Raw) && nr1Raw >= 0 ? nr1Raw : DEFAULT_CALCULADORA_PARAMETROS.nr1ValorIndividual,
    comissaoPercentualMaximo:
      Number.isFinite(comissaoMaxRaw) && comissaoMaxRaw >= 0
        ? comissaoMaxRaw
        : DEFAULT_CALCULADORA_PARAMETROS.comissaoPercentualMaximo,
  }
}

export const comercialCalculadorasService = {
  async listParameters(): Promise<ComercialCalculadoraParameter[]> {
    const { data, error } = await supabase
      .from('calc_parameters')
      .select('*')
      .order('key', { ascending: true })

    if (error) throw error
    return (data || []) as ComercialCalculadoraParameter[]
  },

  async updateParameter(
    id: string,
    data: { value: string; description?: string }
  ): Promise<ComercialCalculadoraParameter | null> {
    const payload: { value: string; description?: string; updated_at: string } = {
      value: data.value,
      updated_at: new Date().toISOString(),
    }
    if (data.description !== undefined) {
      payload.description = data.description
    }

    const { data: result, error } = await supabase
      .from('calc_parameters')
      .update(payload)
      .eq('id', id)
      .select()
      .single()

    if (error) throw error
    return result as ComercialCalculadoraParameter
  },

  async getParametrosConfig(): Promise<CalculadoraParametrosConfig> {
    const parameters = await this.listParameters()
    return parseCalculadoraParametros(parameters)
  },
}
